export const ACCOUNT_TYPE = 'ACCOUNT_TYPE';